import moment from 'moment';

export const getAuthToken = () => {
  let token = localStorage.getItem('token');

  return token;
};

export const getLoggedInUserRole = () => {
  let role = localStorage.getItem('user_role');
  return role;
};

export const getLoggedInUserId = () => {
  let id = localStorage.getItem('user_id');
  return id;
};

export const isUserAllowed = (userRole, roleArray) => {
  return roleArray.includes(userRole);
};

export const isTrainingAddedByLoggedInUser = (trainingUserId) => {
  return parseInt(trainingUserId) === parseInt(getLoggedInUserId());
};

export const isEndDateAvailable = (trainingObj) => {
  let { end_date, end_time } = trainingObj;

  return end_date && end_time;
};

export const isEndDateExceeded = (trainingObj) => {
  let { end_date, end_time } = trainingObj;

  let currentTimeStamp = moment();
  let currentDate = moment(currentTimeStamp).format('YYYY-MM-DD');
  let currentTime = moment(currentTimeStamp).format('HH:mm');

  return currentDate >= end_date && currentTime > end_time;
};

export const formatUserFileUploadDate = (date) => {
  if (!date) return '-';
  if (typeof date === 'string' && /^\d{4}\/\d{2}\/\d{2}$/.test(date)) {
    return date;
  }
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format('YYYY/MM/DD') : '-';
};

export const formatUserFileExpiryDate = (date) => {
  if (!date) return '-';
  if (typeof date === 'string' && date.includes('/')) {
    return date;
  }
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format('YYYY/MM/DD') : '-';
};

export const toUserFileDateInputValue = (date) => {
  if (!date) return '';
  if (typeof date === 'string' && date.includes('/')) {
    const [year, month, day] = date.split('/');
    return `${year}-${month}-${day}`;
  }
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
};
